import { render, staticRenderFns } from "./basket-mini.vue?vue&type=template&id=403cc3f6"
import script from "./basket-mini.vue?vue&type=script&lang=js"
export * from "./basket-mini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports